import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import React from "react";

interface BreadcrumbSeparatorProps {
  /** Additional CSS classes */
  className?: string;
}

/**
 * BreadcrumbSeparator - Atom component
 *
 * Displays a chevron separator for breadcrumb navigation.
 * Part of the atomic design system for folder tree display.
 *
 * @example
 * ```tsx
 * <BreadcrumbSeparator />
 * <BreadcrumbSeparator className="mx-2" />
 * ```
 */
export const BreadcrumbSeparator = React.memo(function BreadcrumbSeparator({
  className,
}: BreadcrumbSeparatorProps) {
  return (
    <ChevronRight
      className={cn("mx-1.5 h-3.5 w-3.5 text-slate-400", className)}
      aria-hidden="true"
    />
  );
});
